import { render } from "./PaperSize.vue?vue&type=template&id=2263c5b0"
import script from "./PaperSize.vue?vue&type=script&lang=js"
export * from "./PaperSize.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__